import { Fragment } from 'react';

const Dropdown = props => {
	const {
		entryKey,
		formDetails,
		placeholder,
		handleChange,
		onBlur,
		className,
	} = props;
	return (
		<Fragment>
			<select
				id={entryKey}
				name={entryKey}
				onChange={handleChange}
				onBlur={onBlur}
				className={className}
				value={formDetails.value}
				placeholder={placeholder}
				valid={formDetails.validation && formDetails.validation.valid}
				validationMessage={
					formDetails.validation && formDetails.validation.message
						? formDetails.validation.message
						: ''
				}
				disabled={props.disabled}
			>
				{props.formDetails.options.map(option => {
					return (
						<option
							key={option.key}
							id={option.key}
							value={option.value}
							selected={option.value === formDetails.value}
						>
							{option.value}
						</option>
					);
				})}
			</select>
		</Fragment>
	);
};

export default Dropdown;
